import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
/*------ Pages-----*/
import { Home } from "./Pages/Home";
import DigitalMarketing from "./Pages/Digital-marketing";
import PaymentProcessing from "./Pages/Payment-processing";
import About from "./Pages/About";
import Service from "./Pages/Service";
import Process from "./Pages/Process";
import Team from "./Pages/Team";
import Portfoliofull4col from "./Pages/Portfolio-fullwidth-4col";
import Bloglist from "./Pages/Bloglist";
import BlogSingle from "./Pages/BlogSingle";
import Contact from "./Pages/Contact";
import ScrollToTopRoute from "./ScrollToTopRoute";
import ServiceDetails from "./Pages/ServiceDetails";
import BlogGridPage from "./Pages/BlogGridPage";
import NotFound from "./Pages/404";
import { HomeAcacia } from "./Pages/HomeAcacia";
import { Helmet } from "react-helmet"



class App extends Component {
    componentDidMount() {
        this.props.hideLoader();
    }
    render() {
        return (
            <Router>
                <Switch>
                    
                    <ScrollToTopRoute
                        exact={true}
                        path={"/"}
                        component={Home}
                    />
                    
                    <ScrollToTopRoute
                        path={"/Acacia-Ridge"}
                        component={HomeAcacia}
                        
                    />
                    
                    <ScrollToTopRoute
                        path={"/Brisbane"}
                        component={HomeAcacia}
                        
                    />
                    
                    <ScrollToTopRoute
                        path={"/Beenleigh"}
                        component={HomeAcacia}
                        
                    />
                    
                    <ScrollToTopRoute
                        path={"/Coopers-Plains"}
                        component={HomeAcacia}
                        
                    />
                    
                    <ScrollToTopRoute
                        path={"/Gold-Coast"}
                        component={HomeAcacia}
                    />
                    
                    <ScrollToTopRoute
                        path={"/Ipswich"}
                        component={HomeAcacia}
                        
                    />
                    
                    <ScrollToTopRoute
                        path={"/Rocklea"}
                        component={HomeAcacia}
                        
                    />
                    
                    <ScrollToTopRoute
                        path={"/Sunnybank"}
                        component={HomeAcacia}
                        rel="canonical"
                    />
                    
                    <ScrollToTopRoute
                        path={"/Toowoomba"}
                        component={HomeAcacia}
                        
                    />
                    <ScrollToTopRoute
                        path={"/Underwood"}
                        component={HomeAcacia}
                        
                    />
                    <ScrollToTopRoute
                        path={"/Woodridge"}
                        component={HomeAcacia}
                        
                    />
                    <ScrollToTopRoute
                        path="/Digital-marketing"
                        component={DigitalMarketing}
                        
                    />
                    <ScrollToTopRoute
                        path="/Payment-processing"
                        component={PaymentProcessing}
                    />
                   
                    <ScrollToTopRoute path="/About" component={About} />
                    <ScrollToTopRoute
                        path="/Service"
                        exact
                        component={Service}
                        
                    />
                    <ScrollToTopRoute path="/Process" component={Process} />
                    <ScrollToTopRoute path="/Team" component={Team}  />
                    
                    <ScrollToTopRoute
                        path="/Portfolio-fullwidth-4col"
                        component={Portfoliofull4col}
                        
                    />
                    
                    <ScrollToTopRoute path="/Bloglist" component={Bloglist} />
        <ScrollToTopRoute
            path="/Blog/:blogTitle"
            component={BlogSingle}
        />

                    {/* Redirect /blog-posts to /blog-posts/1 */}
                    <ScrollToTopRoute
                        exact={true}
                        path="/blog-posts"
                        component={() => <Redirect to="/blog-posts/1" />}
                    />

                    {/* Paginated Blog Route */}
                    <ScrollToTopRoute
                        path="/blog-posts/:pageNumber"
                        component={BlogGridPage}
                    />
                    <ScrollToTopRoute path="/Contact" component={Contact} />
                    
                    <ScrollToTopRoute
                        path="/service/:serviceName/:serviceImage"
                        component={ServiceDetails}
                        
                    />
                    {/* <ScrollToTopRoute path="/SignIn" component={SignIn} />
                    <ScrollToTopRoute path="/SignUp" component={SignUp} /> */}
                    <ScrollToTopRoute component={NotFound} />
                </Switch>
            </Router>
        );
    }
}

export default App;
